export default __webpack_public_path__ + "static/media/invisible.9e33846f.svg";